
const HamburgerButton = ({ isOpen, onClick }) => {
  return (
    <button
      onClick={onClick}
      aria-label="Toggle navigation"
      aria-expanded={isOpen}
      className="relative w-9 h-9 flex items-center justify-center rounded-full
                 border border-gray-200 hover:border-primaryFadedColor
                 transition-all duration-300 lg:hidden"
    >
      <div className="relative w-6 h-4">
        <span
          className={`absolute left-0 top-0 h-[2px] w-full rounded-full 
                      bg-primaryNavyTextColor transition-all duration-300
                      ${isOpen ? "translate-y-[7px] rotate-45" : ""}`}
        />
        <span
          className={`absolute left-0 top-1/2 h-[2px] w-full rounded-full 
                      bg-primaryNavyTextColor transition-all duration-300
                      -translate-y-1/2
                      ${isOpen ? "opacity-0 scale-x-0" : "opacity-100 scale-x-100"}`}
        />
        <span
          className={`absolute left-0 bottom-0 h-[2px] w-full rounded-full 
                      bg-primaryNavyTextColor transition-all duration-300
                      ${isOpen ? "-translate-y-[7px] -rotate-45" : ""}`}
        />
      </div>
    </button>
  );
};

export default HamburgerButton;
